import React, { ReactNode } from 'react';

import { Button } from '@infoods/lifebase-ui';

import classes from './ReleaseNotesCell.module.scss';
import { GridTableCell } from '../../../../../shared/components/table-components';
import { ReleaseInfo } from '../../../../interfaces/ReleaseInfo';
import { ReleaseNotesModal } from '../ReleaseNotesModal/ReleaseNotesModal';
import { openModal } from '../../../../../shared/utils/reactUtils/openModal/openModal';

type ReleaseNotesCellProps = Pick<ReleaseInfo, 'shortNotes' | 'fullNotes'>;

const openNotesModal = (fullNotes: ReactNode) =>
  openModal((closeModal) => <ReleaseNotesModal notes={fullNotes} onClose={closeModal} />);

const ReleaseNotesCell = ({ shortNotes, fullNotes }: ReleaseNotesCellProps) => {
  if (!shortNotes) {
    return (
      <GridTableCell className={classes.emptyNotes}>
        No release notes added yet
      </GridTableCell>
    );
  }

  return (
    <GridTableCell>
      {shortNotes}
      {!!fullNotes && (
        <>
          {'… '}
          <Button
            variant="text"
            size="small"
            className={classes.button}
            onClick={() => openNotesModal(fullNotes)}
          >
            See More
          </Button>
        </>
      )}
    </GridTableCell>
  );
};

export { ReleaseNotesCell };
